import { Box, CircularProgress } from '@mui/material';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSession } from '@/features/auth';
import type { Role } from '@/shared/api/types';

export function RequireAuth({ roles }: { roles?: Role[] }) {
  const { user, isLoading } = useSession();
  const location = useLocation();
  if (isLoading) return <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}><CircularProgress /></Box>;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return <Outlet />;
}
